import { useCallback, useEffect, useState } from "react";

export function useForcedRefresh() {
    const [forcedRefresh, setForcedRefresh] = useState<Date>(new Date());
    const update = useCallback(() => setForcedRefresh(new Date()), []);

    return {
        forcedRefresh,
        update
    };
}
